import React from 'react';
import {Box} from '@material-ui/core';
import PropTypes from 'prop-types';

const VideoContent = ({children}) => <Box>{children}</Box>;

VideoContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default VideoContent;
